function bindChat() {
  const el = document.querySelector('#shopify-chat inbox-online-store-chat');
  if (!el) return false;

  const sync = () => {
    el.style.setProperty('transform', el.getAttribute('is-open') === 'true' ? 'scale(1)' : 'scale(0.75)', 'important');
    el.style.transformOrigin = 'bottom left';
  };

  sync();
  new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['is-open'] });
  return true;
}

// widget loads async, so retry until the element exists
if (!bindChat()) {
  const t = setInterval(() => { if (bindChat()) clearInterval(t); }, 300);
}